import { useSyncExternalStore } from "react";

export function useIsTouchDevice() {
    return useSyncExternalStore(
        subscribeToTouchCapability,
        getTouchSnapshot,
        () => false,
    );
}

function subscribeToTouchCapability(onStoreChange: () => void) {
    const mediaQuery = window.matchMedia("(pointer: coarse)");
    mediaQuery.addEventListener("change", onStoreChange);
    return () => {
        mediaQuery.removeEventListener("change", onStoreChange);
    };
}

function getTouchSnapshot() {
    return (
        window.matchMedia("(pointer: coarse)").matches || navigator.maxTouchPoints > 0
    );
}
